import React from "react";
import {
  VideoResourceTile,
  SliceConfig,
  Button,
  SwiperCarousel,
  IntersectionAnimation
} from "~components";
import cn from "classnames";
import * as styles from "./styles.module.scss";

const VideoResources = ({ title, resourceTiles, linkButton, sliceConfig }) => (
  <SliceConfig config={sliceConfig}>
    <h2 className={cn(`h2`, styles.title)}>{title}</h2>

    {/* Mobile Carousel */}
    <SwiperCarousel className={styles.carousel}>
      {resourceTiles?.map((tile, i) => (
        <VideoResourceTile
          key={i}
          title={tile.title}
          image={tile.image}
          description={tile.description}
          link={tile.link}
          video={tile.video}
          linkIcon={tile.linkIcon}
        />
      ))}
    </SwiperCarousel>

    {/* Desktop Grid */}
    <div className={styles.tileGrid}>
      {resourceTiles?.map((tile, i) => (
        <IntersectionAnimation animation="fadeGrow" key={i} delay={i * 100}>
          <VideoResourceTile
            title={tile.title}
            image={tile.image}
            description={tile.description}
            link={tile.link}
            video={tile.video}
            linkIcon={tile.linkIcon}
          />
        </IntersectionAnimation>
      ))}
    </div>
    {linkButton && (
      <div className={styles.buttonContainer}>
        <Button
          to={`/${linkButton.reference.slug.current}`}
          variant="secondary"
        >
          {linkButton.title}
        </Button>
      </div>
    )}
  </SliceConfig>
);

export default VideoResources;
